import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import useSWR from 'swr';
import { useState } from 'react';
import { fetcher } from '@yoweb/utils/common';
import { API_TASK_TEMPLATE_CUSTOM, API_TASK_TEMPLATE_ID } from '@poplar/constants/routes';
import { Wrapper } from './Wrapper';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { useTranslation } from '@yoweb/next-i18next';
import { uploadIntakeFiles } from '@poplar/components/Questions/intake-form/utils';
import { useUser } from '@poplar/hooks/useUser';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { AccessType } from '@poplar/types/enums';
import { jsx as _jsx } from "react/jsx-runtime";
export var TemplatedNew = function TemplatedNew(_ref) {
  var _data$title, _data$questionsList;

  var taskTemplateId = _ref.taskTemplateId,
      initialError = _ref.initialError,
      onDirtyChange = _ref.onDirtyChange,
      onSlideBack = _ref.onSlideBack,
      onSlideClose = _ref.onSlideClose,
      onSubmitted = _ref.onSubmitted,
      isSubscriptionFlow = _ref.isSubscriptionFlow,
      initialTaskTitle = _ref.initialTaskTitle;

  var _useExternalConfig = useExternalConfig(),
      globalFeatures = _useExternalConfig.globalFeatures;

  var _useEntitlement = useEntitlement(),
      accessType = _useEntitlement.accessType;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      watchSafeFetch = _useUser.actions.watchSafeFetch; // If not task template, fetch templated Type C


  var TEMPLATE_ENDPOINT = taskTemplateId ? API_TASK_TEMPLATE_ID(taskTemplateId) : API_TASK_TEMPLATE_CUSTOM;
  var hasActiveSubscription = globalFeatures.enableOnboarding2_2 && (accessType === AccessType.FULL || accessType === AccessType.LIMITED);

  var _useSWR = useSWR(isAuthenticated ? TEMPLATE_ENDPOINT : undefined, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }),
      data = _useSWR.data,
      fetchError = _useSWR.error,
      isLoading = _useSWR.isLoading;

  var _useToast = useToast(),
      showToastMessage = _useToast.showToastMessage;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useTasks = useTasks(),
      handoffTaskAction = _useTasks.actions.handoffTask;

  var _useState = useState(initialError),
      error = _useState[0],
      setError = _useState[1]; // Controls whether the user can navigate back or exit the flyout. Disable both buttons when saving/handoff


  var _useState2 = useState(true),
      allowNavigation = _useState2[0],
      setAllowNavigation = _useState2[1];

  var onSaveDraft = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(questionsList, saveTask, onSubmitSuccess) {
      var savedTask;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setAllowNavigation(false);
              _context.next = 4;
              return uploadIntakeFiles(questionsList, watchSafeFetch);

            case 4:
              _context.next = 6;
              return saveTask({
                taskTemplateId: taskTemplateId,
                questionsList: questionsList
              });

            case 6:
              savedTask = _context.sent;
              onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted(savedTask);
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              setError(_context.t0);
              throw _context.t0;

            case 14:
              _context.prev = 14;
              setAllowNavigation(true);
              return _context.finish(14);

            case 17:
              onSlideClose(true);
              showToastMessage({
                message: t('task-draft-saved')
              });
              onSubmitSuccess();

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10, 14, 17]]);
    }));

    return function onSaveDraft(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onHandOff = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(questionsList, saveTask, onSubmitSuccess) {
      var savedTask;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setAllowNavigation(false);
              _context2.next = 4;
              return uploadIntakeFiles(questionsList, watchSafeFetch);

            case 4:
              _context2.next = 6;
              return saveTask({
                taskTemplateId: taskTemplateId,
                questionsList: questionsList
              });

            case 6:
              savedTask = _context2.sent;
              _context2.next = 9;
              return handoffTaskAction(savedTask, {
                onSuccess: function onSuccess(handedOffTask) {
                  onSlideClose(true);
                  onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted(handedOffTask);
                },
                skipValidation: savedTask.readyToHandOff
              });

            case 9:
              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              setError(_context2.t0);
              throw _context2.t0;

            case 15:
              _context2.prev = 15;
              setAllowNavigation(true);
              return _context2.finish(15);

            case 18:
              onSubmitSuccess();

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11, 15, 18]]);
    }));

    return function onHandOff(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var title = initialTaskTitle ? initialTaskTitle : (_data$title = data === null || data === void 0 ? void 0 : data.title) !== null && _data$title !== void 0 ? _data$title : data === null || data === void 0 ? void 0 : data.titlePlaceholderText;
  var questions = isSubscriptionFlow && title ? data === null || data === void 0 ? void 0 : (_data$questionsList = data.questionsList) === null || _data$questionsList === void 0 ? void 0 : _data$questionsList.filter(function (question) {
    return question.id !== 'question_type_c_todo_display_name';
  }) : data === null || data === void 0 ? void 0 : data.questionsList;
  return /*#__PURE__*/_jsx(Wrapper, {
    questionsList: questions,
    title: title,
    description: data === null || data === void 0 ? void 0 : data.description,
    onSlideClose: onSlideClose,
    onSlideBack: onSlideBack,
    error: fetchError !== null && fetchError !== void 0 ? fetchError : error,
    isLoading: isLoading,
    onHandOff: onHandOff,
    onSaveDraft: onSaveDraft,
    onDirtyChange: onDirtyChange,
    allowNavigation: allowNavigation,
    taskTemplateId: taskTemplateId,
    isSubscriptionFlow: isSubscriptionFlow,
    hasActiveSubscription: hasActiveSubscription
  });
};